import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/transhumans/new-beginnings.png")